import { IUserResetPassword } from "@fl/shared/src/types/usuarios";
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { recuperarSenhaSchema } from "../../schemas/users";
import ApiUsers from "../../services/suporte/users";
import ParamsFuncs from "../../utils/paramsFuncs";
import DefaultBasePage from "../default/base"; // ajuste o caminho conforme necessário

export type RecuperacaoFormInputs = IUserResetPassword;

const ResetPasswordUserPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const search = useLocation().search;
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<RecuperacaoFormInputs>({
    resolver: yupResolver(recuperarSenhaSchema),
  });

  const onSubmit: SubmitHandler<RecuperacaoFormInputs> = async (data) => {
    try {
      setLoading(true);
      const result = await new ApiUsers(data).resetPassword();
      navigate("/", { state: result });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const { id, codigo } = new ParamsFuncs(search).getConfirmUser();
    if (id) setValue("id", parseInt(id)); //Inserção manual de valores no hook
    if (codigo) setValue("codigo", codigo);
  }, []);

  return (
    <DefaultBasePage title="Confirmação de Usuário" loading={loading}>
      <div className="d-flex justify-content-center">
        <Form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Row className="mt-2">
            <Col className="mt-1">
              <Form.Group controlId="formId">
                <Form.Label>ID:</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="ID do usuário"
                  {...register("id")}
                  isInvalid={!!errors.id}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.id?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col className="mt-1">
              <Form.Group controlId="formCodigo">
                <Form.Label>Código:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Código de validação"
                  {...register("codigo")}
                  isInvalid={!!errors.codigo}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.codigo?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col className="mt-1">
              <Form.Group controlId="formSenha">
                <Form.Label>Senha:</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Digite a senha"
                  {...register("senha")}
                  isInvalid={!!errors.senha}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.senha?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col className="mt-1">
              <Form.Group controlId="formConfirmarSenha">
                <Form.Label>Confirmar Senha:</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Confirme a senha"
                  {...register("confirmarSenha")}
                  isInvalid={!!errors.confirmarSenha}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.confirmarSenha?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-end">
            <Button variant="outline-success" type="submit" className="mt-4">
              Criar Senha
            </Button>
          </div>
        </Form>
      </div>
    </DefaultBasePage>
  );
};

export default ResetPasswordUserPage;
